import { SofturaTable } from "client/CommonComponents";

const Hierarchy = (props: any) => {
    const {
        hierarchyTableTemp,
        approvalHierarchyColumns,
        showGrid
    } = props;

    return (
        <div className={`pe-0 ${hierarchyTableTemp?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
            {showGrid && <SofturaTable
                data={hierarchyTableTemp.current ?? []}
                columns={approvalHierarchyColumns}
                sort={false}
                pagination={false}
                globalSearch={false}
                fixedHeader={true}
                className="approvalHierarchy-grid"
             data-attribute="Hierarchy_Default_Grid" />}
        </div>
    );
}

export default Hierarchy;